'use client';

import { useEffect } from 'react';
import { SHOWCASE_MESSAGE } from '@/lib/showcase-path';

/** Marks the second and later pages of a visit, so only those scroll the host to the top. */
const VISITED_KEY = 'bce-showcase-visited';
export const SHOWCASE_CREDIT_ID = 'showcase-credit';

/**
 * Talks to the snippet on the partner's page (bcecloud partner-showcase.ts):
 * reports the page height so the iframe fits its content, scrolls the host to
 * the top when a visitor opens a program (the frame is as tall as its content,
 * so it cannot scroll itself), and hides our in-frame credit when the host
 * already shows the snippet's credit link under the frame. Framed pages only.
 */
export function ShowcaseFrame() {
  useEffect(() => {
    if (window.parent === window) return undefined;
    const post = (message: Record<string, unknown>) => window.parent.postMessage(message, '*');
    const height = () => post({ type: SHOWCASE_MESSAGE.height, height: Math.ceil(document.body.getBoundingClientRect().height) });

    const onMessage = (event: MessageEvent) => {
      if (event.source !== window.parent || event.data?.type !== SHOWCASE_MESSAGE.attributed) return;
      const credit = document.getElementById(SHOWCASE_CREDIT_ID);
      if (credit) credit.hidden = true;
      height();
    };
    window.addEventListener('message', onMessage);
    post({ type: SHOWCASE_MESSAGE.hello });

    const observer = new ResizeObserver(height);
    observer.observe(document.body);
    height();

    try {
      if (sessionStorage.getItem(VISITED_KEY)) post({ type: SHOWCASE_MESSAGE.scroll, top: 0 });
      sessionStorage.setItem(VISITED_KEY, '1');
    } catch {
      // Storage blocked in a third-party frame: skip the scroll, keep the rest.
    }

    return () => {
      window.removeEventListener('message', onMessage);
      observer.disconnect();
    };
  }, []);
  return null;
}
